import { CopyId } from "./CopyId";
import { Note } from "./Note";
import { t } from "../i18n/strings";

interface GrantConfirmProps {
  userId: number;
  tokens: number;
  comment: string;
  granting: boolean;
  error: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * The second step of a grant: what is about to happen, and two buttons.
 *
 * There is a second step at all because a grant cannot be taken back - nothing in the project
 * debits a balance on an admin's say-so - so a mis-typed amount is permanent. The confirm
 * button is disabled for the whole flight for the same reason it is on a refund: a second
 * click must not start a second grant.
 */
export function GrantConfirm({ userId, tokens, comment, granting, error, onConfirm, onCancel }: GrantConfirmProps) {
  return (
    <div className="refund-confirm">
      <h2 className="refund-confirm__title">{t("grants.confirmTitle")}</h2>

      <div className="refund-confirm__numbers">
        <span className="card__client">
          {t("grants.client")}
          <CopyId value={userId} />
        </span>
        <span>{t("grants.tokens", { tokens })}</span>
        {comment.trim() ? <span>{t("grants.comment", { comment: comment.trim() })}</span> : null}
      </div>

      {error ? <Note kind="error">{error}</Note> : null}

      <div className="refund-confirm__buttons">
        <button type="button" className="button button--primary" disabled={granting} onClick={onConfirm}>
          {granting ? t("grants.working") : t("grants.confirm")}
        </button>
        <button type="button" className="button button--quiet" disabled={granting} onClick={onCancel}>
          {t("grants.cancel")}
        </button>
      </div>
    </div>
  );
}
